import { Route, Switch } from 'react-router-dom';
import '../stylesheets/content.scss';
import routes from './routes/routes.json';
import NotFound404 from './shared/NotFound404';
import ContentRoutes from './routes/ContentRoutes';
import { ToastContainer } from 'react-toastify';
import '../stylesheets/application/shared/toast.scss';
import MobicipLoader from './shared/MobicipLoader';

function Content() {
  return (
    <>
      <Switch>
        <Route exact path={Object.values(routes.contentroutes)} component={ContentRoutes} />
        <Route path='*' component={NotFound404} />
      </Switch>
      <MobicipLoader />
      <ToastContainer position='bottom-center' hideProgressBar={true} autoClose={3000} />
    </>
  )
}

export default Content;
